
import { createClient } from '@supabase/supabase-js';

// Define Supabase connection information
const supabaseUrl = 'https://jbkkoxrjfnoassvsgyqz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impia2tveHJqZm5vYXNzdnNneXF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk1NzU4MzAsImV4cCI6MjA1NTE1MTgzMH0.FNVjoBN0AfbeZpB3a3rP6JKW6qq5J9vVfq-HInBpLTw';

// Singleton instance of the Supabase client
let supabaseInstance = null;

// Create a single supabase client for interacting with your database
export const supabase = (() => {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true
      },
      db: {
        schema: 'public'
      }
    });
  }
  
  return supabaseInstance;
})();

// Export the URL so it can be used for storage URLs
export const STORAGE_URL = supabaseUrl;
